import { StorefrontPageMetadata } from '../components/StorefrontPageMetadata';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useSearchResultPageMetadata } from '../hooks/useSearchResultPageMetadata';
import { SearchResultsPageStructuredData } from './SearchResultsPageStructuredData';
import { useSearchResultsCanonicalPaths } from './hooks/useSearchResultsCanonicalPaths';
import { useSearchResultsQuery } from './hooks/useSearchResultsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MIN_SEARCH_RESULTS = 3;
export function SearchResultsPageMetadata() {
  var _data$result$cards$le, _data$result$cards;
  const {
    loading,
    data
  } = useSearchResultsQuery();
  const searchParams = useSearchParams();
  const search = searchParams.get('search');
  const canonicalPaths = useSearchResultsCanonicalPaths();
  const {
    title,
    metaDescription
  } = useSearchResultPageMetadata();
  const noIndexNoFollow = search || ((_data$result$cards$le = data === null || data === void 0 || (_data$result$cards = data.result.cards) === null || _data$result$cards === void 0 ? void 0 : _data$result$cards.length) !== null && _data$result$cards$le !== void 0 ? _data$result$cards$le : 0) <= MIN_SEARCH_RESULTS;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StorefrontPageMetadata, {
      canonicalPaths: canonicalPaths,
      loading: loading,
      metaDescription: metaDescription,
      robotsDirective: noIndexNoFollow ? ['nofollow', 'noindex'] : undefined,
      title: title
    }), /*#__PURE__*/_jsx(SearchResultsPageStructuredData, {})]
  });
}